// extracted by mini-css-extract-plugin
export var container = "_g0-0";
export var icon = "_g0-1";
export var text = "_g0-2";